module.exports = __webpack_public_path__ + "img/logo.7042a855.png";